import styled from 'styled-components';

export const MainContainer = styled.div`
  padding: 0 30vw;
  display: flex;
  justify-content: center;
`;
